import { PageHero } from "../components/PageHero";
import { FadeUp } from "../components/Reveal";
import { VideoPlayer } from "../components/VideoPlayer";
import { EditorialMarquee } from "../components/EditorialMarquee";
import { IMAGES } from "../data/content";
import { useLang } from "../i18n/i18n";

export default function Media() {
  const { t } = useLang();
  const m = t.media;
  return (
    <div data-testid="media-page">
      <PageHero
        index="/ 04"
        kicker={m.kicker}
        titleLines={[m.pageTitle1, m.pageTitle2]}
        subtitle={m.pageSub}
      />

      <section data-testid="featured-video-section" className="relative overflow-hidden bg-ink px-6 py-24 md:px-12 md:py-32">
        <div className="pointer-events-none absolute -left-32 top-1/3 h-[400px] w-[400px] rounded-full bg-bluecore/20 blur-[150px]" />
        <div className="relative mx-auto max-w-[1400px]">
          <FadeUp>
            <div className="mb-10 flex items-center gap-4">
              <span className="h-px w-12 bg-crimson" />
              <span className="font-mono text-xs uppercase tracking-[0.28em] text-crimson">{m.featured}</span>
            </div>
            <h2 className="max-w-4xl font-serif text-4xl font-light leading-tight text-white md:text-6xl">{m.title}</h2>
          </FadeUp>

          <FadeUp delay={0.15} className="mt-14">
            <VideoPlayer poster={IMAGES.orRoom} />
          </FadeUp>

          <div className="mt-12 grid gap-px border border-white/10 bg-white/10 sm:grid-cols-3">
            {m.h.map((item, i) => (
              <FadeUp key={i} delay={0.1 + i * 0.08}>
                <div className="bg-ink2 p-8">
                  <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-crimson">{item.k}</p>
                  <p className="mt-3 font-serif text-2xl font-light text-white">{item.v}</p>
                </div>
              </FadeUp>
            ))}
          </div>
        </div>
      </section>

      <EditorialMarquee dark />
    </div>
  );
}
